<template>
    <v-card id="monthly-print-buttons">
        <v-card-title>
            <div class="card-title-text pt-3">
                <span class="body-2 font-weight-bold">Havi munkaóra</span><br>
                <span class="display-1 font-weight-thin">Nyomtatás</span>
            </div>
        </v-card-title>
        <div v-if="!genratingPDF">
            <v-container fluid>
                <v-row>
                    <!--
                    <v-col>
                        <v-btn color="primary" class="mb-2" large @click="savePdf(1)"><v-icon>print</v-icon> Aktuális hónap nyomtatása</v-btn>
                    </v-col> -->
                    <v-col>
                        <v-btn color="primary" large @click="savePdf(0)"><v-icon>print</v-icon> Múlt hónap nyomtatása</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div v-else class="pdf-generating-loading mb-5">
            <h3><v-icon>autorenew</v-icon> PDF generálása...</h3>
        </div>
    </v-card>
</template>

<script>
    import download from 'downloadjs'
    export default {
        name: "MonthlyPrint",

        data () {
            return {
                genratingPDF: false,
            }
        },

        methods: {
            async savePdf(getMonth) {
                this.genratingPDF = true
                let year = new Date().getFullYear();
                let month = this.getMonth(getMonth)

                if(month == '00') {
                    month = '12'
                    year = year - 1
                }

                await this.$axios({ url: `/all-montly-pdf/${year}/${month}`, method: 'GET' })
                    .then(resp => {
                        download(`data:application/pdf;base64,${resp.data.pdf}`, `${year}-${month}-havi-munkaorak.pdf` )
                    })
                this.genratingPDF = false
            },

            getMonth(step) {
                return ("0" + (new Date().getMonth() + step)).slice(-2)
            }
        }
    }
</script>

<style lang="scss">
    #monthly-print-buttons {
        button { width: 100%!important;
            i { margin-right: 10px; }
        }

        .pdf-generating-loading {
            background: #efefef;
            width: 96%;
            margin-left: 2%;
            margin-bottom: 15px!important;
            border-radius: 3px;
            padding: 20px;
            text-align: center;

            h3 { font-weight: 300; color: #333; }
        }

        @-webkit-keyframes rotate {
            from {
                -webkit-transform: rotate(0deg);
            }
            to {
                -webkit-transform: rotate(360deg);
            }
        }
        .pdf-generating-loading i
        {
            -webkit-animation-name:             rotate;
            -webkit-animation-duration:         0.5s;
            -webkit-animation-iteration-count:  infinite;
            -webkit-transition-timing-function: inherit;
        }
    }
</style>
